import {Component, OnInit, NgZone} from '@angular/core'
import {AppService} from '../app.service'
import {NbSidebarService, NbMenuService} from '@nebular/theme'
import {AuthService} from '../auth.service'
import {filter, map} from 'rxjs/operators'

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {
  user: any
  profile = [{title: 'Profile'}, {title: 'Logout'}]
  constructor(
    public appService: AppService,
    private nbService: NbSidebarService,
    private nbMenuService: NbMenuService,
    public auth: AuthService
  ) {}

  ngOnInit() {
    this.auth.user$.subscribe(user => {
      this.user = user
    })

    this.nbMenuService
      .onItemClick()
      .pipe(
        filter(({tag}) => tag === 'my-context-menu'),
        map(({item: {title}}) => title)
      )
      .subscribe(title => this.contextMenu(title))
  }
  toggle(tag) {
    this.nbService.toggle(true, tag)
  }
  collapseSB(tag) {
    this.nbService.collapse(tag);
  }

  contextMenu(title) {
    console.log(title)

    if (title == 'Profile') {
      console.log('profile')
    } else if (title == 'Logout') {
      console.log('logout')
      this.auth.signOut()
    }
  }
}
